export default __webpack_public_path__ + "static/media/livedot.e5997fc8.webp";